import React, {
  useRef,
  useState
} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Skeleton } from '@material-ui/lab';

import useGetRequest from 'src/hooks/useGetRequest';
import Label from 'src/components/Label';


const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

function HttpSelector({
  url,
  selectedObjectId,
  objectType,
  getUrl
}: any) {
  const classes = useStyles();
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const { result, isLoading } = useGetRequest({
    url,
    initialResult: [],
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (isLoading) {
    return (
      <Box ml={2}>
        <Skeleton animation="wave" height={20} width={200} />
      </Box>
    );
  }

  /* todo - dont stringify */
  const selectedObject = result.find((obj: any) => obj.id.toString() === selectedObjectId);

  return (
    <>
      <Box
        ml={2}
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        // @ts-ignore
        ref={ref}
      >
        <Typography variant="button">
          {
          selectedObject ? selectedObject.name : (
            <Label color="error">No {objectType} selected</Label>
          )
        }
        </Typography>
        <KeyboardArrowDownIcon />
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        {
          result.map((object: any) => (
            <MenuItem
              key={object.id}
              component={RouterLink}
              to={getUrl(object.id)}
              onClick={() => setOpen(false)}
            >
              {object.name}
            </MenuItem>
          ))
        }
      </Menu>
    </>
  );
}

export default HttpSelector;
